const initState = () => {
  return [];
}

const candidates = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_CANDIDATES":
      const candidates = action.payload.map(i => {return {
        ...i,
        ...{location: i.location ? i.location : ''},
        // ...{country: i.country ? i.country : ''},
        ...{avatar: `${i.avatar}?${new Date().getTime()}`}
      }});
      return candidates;

    default:
      return state;
  }
}

export default candidates;
